import React from "react";
import styled from "styled-components";

const EmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 50px;
`;
const NoDataMsg = styled.h1`
  color: rgb(255, 66, 94);
`;

function NotAuthorized() {
  return (
    <EmptyContainer>
      <NoDataMsg>Not Authorized</NoDataMsg>
    </EmptyContainer>
  );
}

export default NotAuthorized;
